import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance';
import executor from '../../../data/axiosInstance/executor';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;
const REGOLE_AGGREGAZIONE_PATH = '/api/v1/bff/pagamenti/piteco/aggregazione-regole';

const initialState = {
  regoleAggregazione: [],
  regoleLoading: false,
};

export const PitecoSlice = createSlice({
  name: 'piteco',
  initialState,
  reducers: {
    setRegoleAggregazione: (state, action) => {
      state.regoleAggregazione = action.payload;
    },
    setRegoleLoading: (state, action) => {
      state.regoleLoading = action.payload;
    },
  },
});

export const { setRegoleAggregazione, setRegoleLoading } = PitecoSlice.actions;

/**
 * Recupera le regole di aggregazione pagamenti attive da Piteco (AFU v4).
 * Chiamata via BFF: GET /api/v1/bff/pagamenti/piteco/aggregazione-regole
 */
export const fetchRegoleAggregazione = () => async (dispatch) => {
  dispatch(setRegoleLoading(true));
  const API_URI_CALL = `${API_URL}${REGOLE_AGGREGAZIONE_PATH}`;
  const fetchData = async () => axiosInstance.get(API_URI_CALL);
  const [res, err] = await executor.executeAsync(fetchData);
  if (res) {
    dispatch(setRegoleAggregazione(res.data || []));
  } else {
    console.error('fetchRegoleAggregazione error:', err);
    dispatch(setRegoleAggregazione([]));
  }
  dispatch(setRegoleLoading(false));
};

export default PitecoSlice.reducer;

